import * as runtypes from 'runtypes';
import * as system from 'src/models/system';

export const InstitutionSeed = runtypes.Record({
  system: runtypes.Union(system.types.System, runtypes.Literal('mega_banks')),
  localeIdentifier: runtypes.String
});

export type InstitutionSeed = runtypes.Static<typeof InstitutionSeed>;
